import { Navigate, useOutlet } from "react-router-dom";

export const ProtectedLayout = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const outlet = useOutlet();
console.log(user,'useruseruseruser');

  if (!user) {
    return <Navigate to="/login" />;
  }

  return <div>{outlet}</div>;
};
